import {
  CopyToSupplierExistingBehavior,
  PriceRateAdjustmentType,
  PriceRoundingBehavior,
  yupLocalized,
} from "@ryde/shared";

export enum CopyToSupplierPriceRatesForm {
  adjustmentType = "adjustmentType",
  adjustmentValue = "adjustmentValue",
  supplierIds = "supplierIds",
  existingBehavior = "existingBehavior",
  roundingBehavior = "roundingBehavior",
  decimalDigits = "decimalDigits",
}

export interface ICopyToSupplierPriceRatesForm {
  [CopyToSupplierPriceRatesForm.adjustmentType]: PriceRateAdjustmentType;
  [CopyToSupplierPriceRatesForm.adjustmentValue]: number;
  [CopyToSupplierPriceRatesForm.supplierIds]: number[];
  [CopyToSupplierPriceRatesForm.existingBehavior]?: CopyToSupplierExistingBehavior;
  [CopyToSupplierPriceRatesForm.roundingBehavior]?: PriceRoundingBehavior;
  [CopyToSupplierPriceRatesForm.decimalDigits]?: number;
}

export const copyToSupplierPriceRatesValidationSchema = {
  [CopyToSupplierPriceRatesForm.adjustmentType]: yupLocalized
    .string()
    .required(),
  [CopyToSupplierPriceRatesForm.adjustmentValue]: yupLocalized
    .number()
    .required(),
  [CopyToSupplierPriceRatesForm.supplierIds]: yupLocalized
    .array()
    .of(yupLocalized.number())
    .min(1, "At least one supplier must be selected"),
};
